module.exports = __webpack_public_path__ + "static/media/Logo.d48db7be.png";